import { ReactNode } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import PageHero from '@/components/feature/PageHero';
import { company } from '@/mocks/company';

const heroImg = '/assets/klob-hero-legal.jpg';

const facebookUrl = 'https://www.facebook.com/people/Matthias-Klob-GmbH/100064343461794/';

function Fact({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="flex flex-col gap-1.5">
      <dt className="text-[11px] uppercase tracking-[0.2em] text-foreground-400">{label}</dt>
      <dd className="text-base leading-relaxed text-foreground-100/90">{children}</dd>
    </div>
  );
}

function LegalBlock({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="py-8">
      <h2 className="font-display text-xl font-bold uppercase tracking-tight text-foreground-50">{title}</h2>
      <div className="mt-3 leading-relaxed text-foreground-100/75">{children}</div>
    </div>
  );
}

export default function Impressum() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-50 font-sans">
      <Header />
      <main>
        <PageHero
          eyebrow="Rechtliches"
          title={<>Impressum</>}
          subtitle="Angaben gemäß § 5 TMG."
          image={heroImg}
          compact
        />

        <section className="bg-background-50 py-14 lg:py-16">
          <div className="max-w-5xl mx-auto px-6 lg:px-8">
            <div className="rounded-sm border border-background-300/60 bg-background-100 p-7 md:p-10">
              <h2 className="font-display text-3xl font-bold uppercase tracking-tight text-foreground-50">
                {company.name}
              </h2>
              <dl className="mt-7 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-6">
                <Fact label="Anschrift">
                  Krögelstein 93<br />
                  D-96142 Hollfeld
                </Fact>
                <Fact label="Vertreten durch">
                  Matthias Klob<br />
                  Geschäftsführer
                </Fact>
                <Fact label="Telefon">
                  <a href={company.phoneHref} className="text-primary-400 hover:text-primary-300 cursor-pointer transition-colors">
                    {company.phone}
                  </a>
                </Fact>
                <Fact label="E-Mail">
                  <a href={`mailto:${company.email}`} className="break-all text-primary-400 hover:text-primary-300 cursor-pointer transition-colors">
                    {company.email}
                  </a>
                </Fact>
                <Fact label="Handelsregister">
                  HRB 4124<br />
                  Amtsgericht Bayreuth
                </Fact>
                <Fact label="EUID">
                  DED4301V.HRB4124
                </Fact>
                <Fact label="Facebook">
                  <a
                    href={facebookUrl}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-2 text-primary-400 hover:text-primary-300 cursor-pointer transition-colors"
                  >
                    <i className="ri-facebook-circle-line text-lg"></i>
                    Matthias Klob GmbH
                  </a>
                </Fact>
              </dl>
            </div>

            <div className="mt-12 flex flex-col divide-y divide-background-300/40 border-t border-background-300/40">
              <LegalBlock title="Verantwortlich für den Inhalt">
                <p>
                  Verantwortlich im Sinne des § 18 Abs. 2 MStV:<br />
                  Matthias Klob<br />
                  Krögelstein 93<br />
                  D-96142 Hollfeld
                </p>
              </LegalBlock>

              <LegalBlock title="Streitschlichtung">
                <p>
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit. Wir sind nicht
                  verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
                  teilzunehmen.
                </p>
              </LegalBlock>

              <LegalBlock title="Haftung für Inhalte">
                <p>
                  Als Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den
                  allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht
                  verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.
                </p>
              </LegalBlock>

              <LegalBlock title="Haftung für Links">
                <p>
                  Unser Angebot enthält gegebenenfalls Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                  Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber
                  verantwortlich. Zum Zeitpunkt der Verlinkung waren keine rechtswidrigen Inhalte erkennbar.
                </p>
              </LegalBlock>

              <LegalBlock title="Urheberrecht">
                <p>
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
                  Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
                  Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </LegalBlock>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}